module.exports = __webpack_public_path__ + "logo.svg?28b647200d495661c187f291fa339406";


//////////////////
// WEBPACK FOOTER
// ./client/static/logo.svg
// module id = 276
// module chunks = 0